import policy from './policy';

export default function getCookie(cookieName: string) {
    if (policy.deniedCookies()) {
        return '';
    } else {
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(cookieName).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1"))
    }
}

export function removeCookie(name: string) {
    if (getCookie(name)) {
        document.cookie = `${name}=;domain=.mheducation.com;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }
}

export function isCjeCookiePresent() {
    return !!getCookie(COOKIE_CJE);
}

export const COOKIE_USERNAME = 'USERNAME';
export const COOKIE_USEREMAIL = 'USEREMAIL';
export const COOKIE_UID = 'uid';
export const COOKIE_PERSONA_SEGMENT = 'PERSONA_SEGMENT';
export const COOKIE_PERSONA_ROLE = 'PERSONA_ROLE';
export const COOKIE_ERIGHTS = 'ERIGHTS';
export const COOKIE_PERSONA = 'PERSONA';
export const COOKIE_CART = 'MHCART';
export const COOKIE_CART_DOMAIN = ".mheducation.com";
export const COOKIE_CART_PATH = "/";
export const COOKIE_MH_TOKEN = "MH_TOKEN";
export const COOKIE_CJE = 'cje';
